module.exports = __webpack_public_path__ + "img/no-rate.ac59f4b6.svg";